
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadOrders from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { getOrdersDataView, OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { getCookie } from "@insite/mobius/utilities/cookies";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import qs from "qs";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {    
    const getOrdersApiParameterVerify = {
      ...state.pages.orderHistory.getOrdersParameter,
      additionalQueryStringParameters: { isorderverify: true },     
    };  
    getOrdersApiParameterVerify.expand=["orderLines"];
    return {
      settings: getSettingsCollection(state),
      session: getSession(state),
      ordersDataView: getOrdersDataView(state, getOrdersApiParameterVerify),
      getOrdersParameter: state.pages.orderHistory.getOrdersParameter,
      location: getLocation(state),
    };
  };

export interface OrderVerifyPageStyles {
    page?: MobiusPageProps;
}

export const OrderVerifyPageStyles: OrderVerifyPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
};

const mapDispatchToProps = {
    loadOrders,    
    updateSearchFields,    
};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps> & HasHistory;
const styles = OrderVerifyPageStyles;
const OrderVerifyPage: React.FC<Props> = 
({ id,     
    session,
    settings,
    loadOrders,    
    updateSearchFields,
    ordersDataView,
    getOrdersParameter,
    location,
    history,
}) => {
    let firstLoad = false;

     useEffect(() => {            
            firstLoad = true;
            const pageSizeCookie =settings.websiteSettings.defaultPageSize;  getCookie("OrderHistory-PageSize");
            const pageSize = pageSizeCookie || 12;
            if (location.search) {
                const getOrdersApiParameter = parseQueryString<GetOrdersApiParameter>(location.search);
                if (pageSize) {
                    getOrdersApiParameter.pageSize = pageSize;
                }
                updateSearchFields({ ...getOrdersApiParameter, type: "Replace" });
            }else {
                updateSearchFields({ type: "Initialize", pageSize });
            }   
           
        }, []);

          useEffect(() => {
                if (!firstLoad) {
                    const queryString = qs.stringify(getOrdersParameter);
                    history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
                }
            }, [getOrdersParameter]);

            useEffect(() => {
                    // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
                    if (!firstLoad && !ordersDataView.value && !ordersDataView.isLoading) {
                        const getOrdersApiParameter1 ={...getOrdersParameter};
                        getOrdersApiParameter1.additionalQueryStringParameters={"isorderverify": true}
                        getOrdersApiParameter1.expand=["orderLines"]
                        loadOrders(getOrdersApiParameter1);
                    } else if (!ordersDataView.isLoading && ordersDataView.value?.length === 0 && getOrdersParameter.page) {
                        updateSearchFields({ page: getOrdersParameter.page - 1 });
                    }
                });

    const [isLoading, setIsLoading] = React.useState(true);

    return (
         <Page {...styles.page}>          
           <OrdersDataViewContext.Provider value={ordersDataView}>
                <Zone contentId={id} zoneName="Content" />
            </OrdersDataViewContext.Provider>
        </Page>
    );
}

const pageModule: PageModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(OrderVerifyPage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const OrderVerifyPageContext = "OrderVerifyPage";